import { AfterContentChecked, Component, Input, OnInit} from '@angular/core';
import { Subject } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic-input-modal',
  templateUrl: './generic-input-modal.component.html'
})
export class GenericInputModalComponent implements OnInit, AfterContentChecked {

  @Input() modalTitle: string;
  @Input() modalDescription: string;
  @Input() okButton: string;
  @Input() cancelButton: string;
  @Input() inputSuggestion: string;
  @Input() validationPattern: string;
  @Input() patternErrorMessage: string;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() isRequired: boolean;
  @Input() cleanSpaces: boolean;

  modalInput: string;
  input: Subject<string>;

  constructor(
    public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.input = new Subject();
    if (this.cleanSpaces) {
      this.modalInput = this.inputSuggestion.split(' ').join('');
    } else {
      this.modalInput = this.inputSuggestion.split(' ').filter(f => f !== '').join(' ');
    }
  }

  ngAfterContentChecked() {
    const elem = document.getElementById('modalInput');
    elem.focus();
    elem.blur();
    elem.focus();
  }

  onCloseOrCancel() {
    this.input.next(null);
    this.bsModalRef.hide();
  }

  onOK() {
    this.input.next(this.modalInput);
    this.bsModalRef.hide();
  }
}
